/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getSuggestionsSkeleton.defs.js'
export * as $defs from './getSuggestionsSkeleton.defs.js'
